var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.93 4.127a3.127 3.127 0 1 1-6.254 0 3.127 3.127 0 0 1 6.254 0zm10.732 11.746a6.338 6.338 0 1 1-12.676 0 6.338 6.338 0 0 1 12.676 0zM5.775 13.845c1.409 0 2.675-.61 3.55-1.58 1.039-.34 2.133-.572 2.914-.28.663.25 1.383.84 2.009 1.41a1.775 1.775 0 1 0 .785-1.996c-.74.005-1.646-.026-2.373-.344-.865-.378-1.574-1.245-2.114-2.1a4.775 4.775 0 1 0-4.773 4.89zM19.93 27.873a3.127 3.127 0 1 0-6.254 0 3.127 3.127 0 0 0 6.254 0zM5.775 18.155c1.409 0 2.675.61 3.55 1.58 1.039.34 2.133.572 2.914.28.663-.25 1.383-.84 2.009-1.41a1.775 1.775 0 1 1 .785 1.996c-.74-.005-1.646.026-2.373.344-.865.378-1.574 1.245-2.114 2.1a4.775 4.775 0 1 1-4.773-4.89z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElf);
export default __webpack_public_path__ + "static/media/ELF.022bae0464cead418aac59c495d194ff.svg";
export { ForwardRef as ReactComponent };